module.exports = __webpack_public_path__ + "img/orange_009.b8548d64.png";